// material ui icons
import KeyboardArrowLeftRoundedIcon from '@mui/icons-material/KeyboardArrowLeftRounded';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';

// material ui
import { Box, IconButton, Stack, Toolbar, Tooltip } from '@mui/material';

const EnergyTreeNodeAnalysisToolbar = ({
  actions, // optional additional right-side actions (buttons, pickers, etc.)
  filtersOpen,
  onToggleFilters,
  showFilterToggle = false,
  filterToggleTooltip = { open: 'Hide filters', closed: 'Show filters' },
}) => {
  const showToggle = showFilterToggle && typeof onToggleFilters === 'function';

  return (
    <Toolbar disableGutters>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          gap: 2,
        }}
      >
        {/* Right */}
        <Stack direction="row" alignItems="center" spacing={1.5}>
          {actions}

          {showToggle && (
            <Tooltip
              className="non-printable"
              title={
                filtersOpen
                  ? filterToggleTooltip.open
                  : filterToggleTooltip.closed
              }
              placement="top"
            >
              <IconButton
                size="small"
                sx={{
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: '6px',
                }}
                onClick={onToggleFilters}
              >
                {filtersOpen ? (
                  <KeyboardArrowRightRoundedIcon />
                ) : (
                  <KeyboardArrowLeftRoundedIcon />
                )}
              </IconButton>
            </Tooltip>
          )}
        </Stack>
      </Box>
    </Toolbar>
  );
};

export default EnergyTreeNodeAnalysisToolbar;
